export const spacingSizes = [
	{ label: '3xs', value: 'var(--spacing-3xs)' },
	{ label: '2xs', value: 'var(--spacing-2xs)' },
	{ label: 'xs', value: 'var(--spacing-xs)' },
	{ label: 'sm', value: 'var(--spacing-sm)' },
	{ label: 'md', value: 'var(--spacing-md)' },
	{ label: 'lg', value: 'var(--spacing-lg)' },
	{ label: 'xl', value: 'var(--spacing-xl)' },
	{ label: '2xl', value: 'var(--spacing-2xl)' },
	{ label: '3xl', value: 'var(--spacing-3xl)' },
	{ label: '4xl', value: 'var(--spacing-4xl)' },
] as const;

export type SpacingSize = (typeof spacingSizes)[number];
